import React, { useContext, useState, useRef } from "react"
import { firestore } from "../firebase/firebase"

const FormContext = React.createContext()

export function useForm() {
  return useContext(FormContext);
}

export function FormProvider({ children }) {

  const [forms, setForms] = useState([]);
  const [formsLoading, setFormsLoading] = useState(true);
  const [error, setError] = useState('');
  const formsFetched = useRef(false);

  function getForms() {
    // Fetch once per session; later calls reuse the cached forms state
    if (formsFetched.current) { return; }
    formsFetched.current = true;
    setFormsLoading(true);

    Promise.all([
      firestore.collection("pdfforms").get(),
      firestore.collection("documents").get(),
    ])
      .then(([formSnapshot, documentSnapshot]) => {
        const formResponse = formSnapshot.docs.map(doc => ({
          ...doc.data(),
          'docId': doc.id,
        }));

        let formTitles = formResponse.map(form => form.name);

        documentSnapshot.docs.forEach(doc => {
          const docName = doc.data().name;
          // skip unnamed docs, matching the old query behavior
          if (docName != null && !formTitles.includes(docName)) {
            formResponse.push({ name: docName });
            formTitles.push(docName);
          }
        });

        setFormsLoading(false);
        setForms(formResponse);
      })
      .catch(error => {
        formsFetched.current = false;
        setFormsLoading(false);
        setError(error.message);
      });
  }
  
  function getForm(name) {
    return forms?.filter(form => form.name === name)
  }

  const value = {
    forms,
    formsLoading,
    error,
    getForms,
    getForm,
  }

  return (
    <FormContext.Provider value={value}>
      {children}
    </FormContext.Provider>
  )
}